export default "/images/framework/GoGameLobby.cbc718ed.svg?cbc718ed";